'use strict';

import '../css/app.scss';
import Ready from './ready.js';

async function loadJQuery() {
  const {default: jQuery} = await import(
    /* webpackChunkName: "jquery" */
    'jquery/dist/jquery'
  );
  return jQuery;
}

async function loadBootstrap() {
  return await new Promise(async (resolve, reject) => {
    const {default: Bootstrap} = await import(
      /* webpackChunkName: "bootstrap" */
      'bootstrap/dist/js/bootstrap'
    );
    resolve(Bootstrap);
  });
}

async function loadFontAwesome() {
  return await new Promise(async (resolve, reject) => {
    const {default: FontAwesome} = await import(
      /* webpackChunkName: "font-awesome" */
      './font-awesome.js'
    );
    resolve(FontAwesome);
  });
}

async function loadDice() {
  return await new Promise(async (resolve, reject) => {
    if (!document.querySelector('.js-dice')) {
        reject();
    }
    const {default: Dice} = await import(
      /* webpackChunkName: "dice" */
      './dice.js'
    );
    resolve(new Dice());
  });
}

async function loadLotto() {
  return await new Promise(async (resolve, reject) => {
    if (!document.querySelector('.js-lotto')) {
        reject();
    }
    const {default: Lotto} = await import(
      /* webpackChunkName: "lotto" */
      './lotto.js'
    );
    resolve(new Lotto());
  });
}

async function loadCuratedLinks() {
  return await new Promise(async (resolve, reject) => {
    if (!document.querySelector('.js-curated-links')) {
        reject();
    }
    const {default: CuratedLinks} = await import(
      /* webpackChunkName: "curated-links" */
      './curated-links/curated-links.js'
    );
    resolve(new CuratedLinks());
  });
}

Ready(() => {
  loadBootstrap();
  loadFontAwesome();

  loadJQuery().then((jQuery) => {
    /* fix for https://github.com/symfony/webpack-encore/pull/54 */
    global.$ = global.jQuery = jQuery;
    require('./apps.js');
  });

  loadDice().then((Dice) => {Dice.initialize();}).catch(() => {});
  loadLotto().then((Lotto) => {Lotto.initialize();}).catch(() => {});
  loadCuratedLinks().then((CuratedLinks) => {CuratedLinks.initialize();}).catch(() => {});
});
